import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { firebaseAuth } from '../../providers/AuthProvider';

const Profile = () => {
  const navigate = useNavigate();
  const { user, handleSignout } = useContext(firebaseAuth);

  useEffect(() => {
    if (!user || !user?.isAuthenticated) navigate('/manage/sign-in');
  }, [user, navigate]);

  const onSignOut = async () => {
    await handleSignout();
    navigate('/manage/sign-in');
  };

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">Your profile</h1>
      <div className="mt-6 divide-y divide-zinc-200 rounded-lg bg-zinc-50 shadow-sm ring-1 ring-zinc-200 dark:divide-zinc-700 dark:bg-zinc-900 dark:ring-zinc-700">
        <div className="flex items-center justify-between gap-4 px-4 py-4">
          <div>
            <div className="text-sm font-medium text-zinc-900 dark:text-zinc-100">Email address</div>
            <div className="mt-1 text-sm text-zinc-600 dark:text-zinc-300">{user?.email}</div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-4">
          <div>
            <div className="text-sm font-medium text-zinc-900 dark:text-zinc-100">
              Multi-factor authentication
            </div>
            <div className="mt-1 text-sm text-zinc-600 dark:text-zinc-300">
              {user?.multiFactor
                ? 'Enabled. Contact support@core12.com to reset.'
                : 'Not enabled.'}
            </div>
          </div>
          {!user?.multiFactor && (
            <Link
              to="/manage/mfa"
              className="inline-flex items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100"
            >
              Enable MFA
            </Link>
          )}
        </div>
      </div>

      <div className="mt-6">
        <button
          type="button"
          onClick={onSignOut}
          className="inline-flex items-center justify-center rounded-md bg-zinc-50 px-3 py-2 text-sm font-semibold text-zinc-900 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:hover:bg-zinc-700"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default Profile;
